import { render, staticRenderFns } from "./OnePagePreview.vue?vue&type=template&id=4dcfc48c&scoped=true&"
import script from "./OnePagePreview.vue?vue&type=script&lang=js&"
export * from "./OnePagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfc48c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dcfc48c')) {
      api.createRecord('4dcfc48c', component.options)
    } else {
      api.reload('4dcfc48c', component.options)
    }
    module.hot.accept("./OnePagePreview.vue?vue&type=template&id=4dcfc48c&scoped=true&", function () {
      api.rerender('4dcfc48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/pages/OnePagePreview.vue"
export default component.exports